// extracted by mini-css-extract-plugin
export default {"Header":"Header_Header__PpAHw","inner":"Header_inner__6O6yV"};